const SuggestionCard = {
	comments: ' Comentários'
}

export default SuggestionCard;